<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
      <button-export
        :href="exportUrl"
        download="download.xls"
        :beforeDownload="beforeDownload"
        v-if="permissionCodes.indexOf('004013001') !== -1"
        value="导出"/>
      </div>
      <input-search placeholder="车主姓名/车牌号" @search="searchKey" />
    </div>
    <div class="search-line">
      <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                      :picker-options="pickerOptions2" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <div class="btn-box" style="display: flex;justify-content: center">
        <input-select selectTitle="进出类型" :selectKey="'carAccessType'" :selectData="carAccessTypeList" @search="search" style="margin-right: 10px"/>
        <input-select selectTitle="停车类型" :selectKey="'parkingType'" :selectData="parkingTypeList"/>
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" @lookOver="lookOver" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "enter-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "进出记录"
        }
      ],
      addController: "controller-add",
      exportUrl: "",
      timevalue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      carAccessTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "进场"
        },
        {
          key: "2",
          label: "出场"
        },
        {
          key: "3",
          label: "进/出"
        }
      ],
      parkingTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "包月车"
        },
        {
          key: "2",
          label: "临停车"
        },
        {
          key: "3",
          label: "无牌车"
        },
        {
          key: "4",
          label: "白名单车"
        },
        {
          key: "5",
          label: "黑名单车"
        }
      ],
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "personName",
          label: "车主姓名"
        },
        {
          prop: "enterpriseName",
          label: "车辆所属住户"
        },
        {
          prop: "deviceName",
          label: "出入口"
        },
        {
          prop: "parkingTypeText",
          label: "车辆类型",
          width: "80"
        },
        {
          prop: "carAccessTypeText",
          label: "进出类型",
          width: "80"
        },
        {
          prop: "carPicSnapUrl",
          label: "抓拍图片(小图)",
          isPreviewPic: true
        },
        {
          prop: "carPicUrl",
          label: "抓拍图片(大图)",
          isPreviewPic: true
        },
        {
          prop: "operatorName",
          label: "操作人"
        },
        {
          prop: "carAccessTime",
          label: "进出时间",
          width: "180"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        startTime: "",
        endTime: "",
        searchKey: "",
        carAccessType: "",
        parkingType: ""
      },
      lookOverImg: "",
      dialogVisible: false
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    // this.exportUrl = `${api.exportCarAccessRecordPage}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    this.getCreateTime();
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportCarAccessRecordPage}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&carAccessType=${this.requestData.carAccessType}&parkingType=${
        this.requestData.parkingType
      }`;
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-01" + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    // 获取进出记录
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getCarAccessRecordPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.carAccessType === "1") {
              v.carAccessTypeText = "进场";
            } else if (v.carAccessType === "2") {
              v.carAccessTypeText = "出场";
            } else if (v.carAccessType === "3") {
              v.carAccessTypeText = "进/出";
            }
            if (v.parkingType === "1") {
              v.parkingTypeText = "包月车";
            } else if (v.parkingType === "2") {
              v.parkingTypeText = "临停车";
            } else if (v.parkingType === "3") {
              v.parkingTypeText = "无牌车";
            } else if (v.parkingType === "4") {
              v.parkingTypeText = "白名单车";
            } else if (v.parkingType === "5") {
              v.parkingTypeText = "黑名单车";
            }
            if (!v.carPicSnapUrl) {
              v.carPicSnapUrl = "";
            }
            if (!v.carPicUrl) {
              v.carPicUrl = "";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取进出记录失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    lookOver(imgUrl) {
      this.lookOverImg = imgUrl;
      this.dialogVisible = true;
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/EnterRecord/EnterRecord.vue